var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tippy",rawName:"v-tippy"}],staticClass:"text-warning cursor-pointer",attrs:{"content":_vm.helperText}},[_c('i',{staticClass:"fas fa-info-circle text-warning font-size-base pulse pulse-warning d-inline-block px-2"})])
}
var staticRenderFns = []

export { render, staticRenderFns }